import { getConstant } from '../utils';

export const getCalculatorsSoilDepth = getConstant('GET_CALCULATORS_SOIL_DEPTH');
export const getCalculatorsSoilDepthItem = getConstant('GET_CALCULATORS_SOIL_DEPTH_ITEM');